// mds-dojo — FAITHFUL port of dojox/widget/_CalendarYear (dojo 1.x). declare from declare-runtime;
// dojo/text!./Calendar/X.html → import ?raw. Upgrades the earlier deliberate STUB to a full port.
import declare from '../../dojo/_base/declare-runtime';
import _CalendarYearView from './_CalendarYearView';
export default declare("dojox.widget._CalendarYear", null, {
		// summary:
		//		Mixin class for adding a view listing 12 years to the
		//		dojox/widget/_CalendarBase

		parent: null,

		constructor: function(){
			// summary:
			//		Adds a dojox/widget/_CalendarYearView view to the
			//		dojo/widget/_CalendarBase widget.
			this._addView(_CalendarYearView);
		}
	});
